export function formatDate(iso: string): string {
  const d = new Date(iso);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function formatDateTime(iso: string): string {
  const d = new Date(iso);
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${formatDate(iso)} ${hh}:${mm}`;
}

export function relativeTime(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  const min = Math.floor(diff / 60000);
  if (min < 1) return '刚刚';
  if (min < 60) return `${min}分钟前`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h}小时前`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d}天前`;
  return formatDate(iso);
}

export function formatViews(n: number): string {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return String(n);
}

export function highlightText(text: string, keyword: string) {
  if (!keyword.trim()) return [{ text, match: false }];
  const lower = text.toLowerCase();
  const kw = keyword.toLowerCase();
  const parts: { text: string; match: boolean }[] = [];
  let index = 0;
  let found = lower.indexOf(kw, index);
  while (found !== -1) {
    if (found > index) parts.push({ text: text.slice(index, found), match: false });
    parts.push({ text: text.slice(found, found + keyword.length), match: true });
    index = found + keyword.length;
    found = lower.indexOf(kw, index);
  }
  if (index < text.length) parts.push({ text: text.slice(index), match: false });
  return parts;
}